export class CollectionsBoardApprovalDocumentRawDto {
    fileName: string;
    mode: string;
    // OWNER - Owner file, COMMUNITY - Community file, LOCAL - Local file

    fileBase64String: string;
    fileId: number;
    communityId: number;
    customerId: string;
}
